import { render } from "./SettingsDatatableTDTagTitle.vue?vue&type=template&id=a989b388&scoped=true"
import script from "./SettingsDatatableTDTagTitle.vue?vue&type=script&lang=js"
export * from "./SettingsDatatableTDTagTitle.vue?vue&type=script&lang=js"

import "./SettingsDatatableTDTagTitle.vue?vue&type=style&index=0&id=a989b388&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a989b388"]])

export default __exports__